import type { ReactNode } from 'react';
import { Box, useBreakpointValue, useTheme } from '@chakra-ui/react';

import { useDocumentSelection, useQueryParams } from '@izimi/hooks';

export const UploadZonePositioningWrapper = ({ children }: { children: ReactNode }) => {
  const sideBarWidthOffset = useBreakpointValue(
    {
      md: '330px',
      '2xl': '450px',
    },
    { ssr: false },
  );
  const { activeDocumentId } = useDocumentSelection();
  const { params } = useQueryParams();
  const theme = useTheme();
  const isSideBarVisible = Boolean(activeDocumentId || params.historyLog);

  return (
    <Box
      transition='0.2s'
      pos='absolute'
      px={{ base: 4, md: 0 }}
      bottom={4}
      right={{
        base: 'initial',
        md: isSideBarVisible ? `calc(${sideBarWidthOffset} + 1rem)` : 4,
      }}
      w={{ base: '100%', md: 'md' }}
      zIndex={theme?.zIndices?.popover}>
      {children}
    </Box>
  );
};
